@if (condition) {
  <div class="padding">
    <div class="flex-container-center margin-top-bottom-25">
      <mat-icon [class]="this.iconClass">{{ iconName }}</mat-icon>
    </div>
    @if (message) {
      <div class="flex-container-center">
        {{ message }}
      </div>
    }
  </div>
}